import React from 'react';
import { CampaignConfigDto, DiscountDto } from '@coretava/api/ecommerce-service';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { formatCampaignReward, formatDiscountValue } from '../../utils';
import Gift from './assets/Gift';

const BasicCampaignHeader: React.FC<{ campaign: CampaignConfigDto, discount?: DiscountDto }> = ({ campaign, discount }) => {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box minWidth={35}>
        <Gift color={theme.palette.primary.main} />
      </Box>
      <Typography fontSize={16} fontWeight={700}>
        <Trans
          i18nKey="campaigns.boosters.basic.gift"
          defaults="{{discountValue}} Gift"
          values={{
            discountValue: discount ? formatDiscountValue(discount) : formatCampaignReward(campaign),
          }}
        />
      </Typography>
    </Box>
  );
};

export default BasicCampaignHeader;
